import React from "react";

import useDataTable, { DataTableHook, ParamsType } from "commons/hooks/useDataTable";

import storage from "commons/utils/storage";

export type PropsType<T> = ParamsType<T> & {
    key: string;
};

function useDataTableWithMemory<T>(props: PropsType<T>): DataTableHook<T> {
    const getInitialPageKey = React.useCallback(() => `data-table-page-${props.key}`, [props.key]);
    const getSortKey = React.useCallback(() => `data-table-sort-${props.key}`, [props.key]);

    const initialPage = React.useMemo(() => {
        const storedInitialPage = storage.get(getInitialPageKey());

        if (storedInitialPage === null) {
            return props.initialPage;
        } else {
            return storedInitialPage;
        }
    }, [getInitialPageKey, props.initialPage]);

    const sortDefault = React.useMemo(() => {
        const storedSort = storage.get(getSortKey());

        if (storedSort === null) {
            return props.sortDefault;
        } else {
            return storedSort;
        }
    }, [getSortKey, props.sortDefault]);

    const dataTableHook = useDataTable({ ...props, initialPage, sortDefault });

    React.useEffect(() => {
        storage.set(getInitialPageKey(), dataTableHook.page);
    }, [getInitialPageKey, dataTableHook.page]);

    React.useEffect(() => {
        storage.set(getSortKey(), dataTableHook.sort);
    }, [getSortKey, dataTableHook.sort]);

    return dataTableHook;
}

export default useDataTableWithMemory;
